<script>
    import user from './stores/user';
    import {createEventDispatcher} from 'svelte';
    import {convertMessage, formatDate, dateToSchedule} from "./lib/lib";
    import {validateSms, sendSms} from "./requests";
    import MobilesContainer from "./components/MobilesContainer.svelte";

    export let message;
    export let showConfirm = false;

    const dispatch = createEventDispatcher();

    let totalInvalidMobiles = 0;
    let totalDoubleMobiles = 0;
    let totalMobiles = 0;
    let invalidMobiles = '';
    let showInvalidMobiles = false;
    let error = "";
    let messageSended = false;


    const Validate = async () => {
        messageSended = false;

        const [err, res] = await validateSms(message);

        if (err) {
            error = err;
            return;
        }

        totalInvalidMobiles = res.total_invalid_mobiles;
        totalDoubleMobiles = res.total_double_mobiles;
        totalMobiles = res.total_mobiles;
        invalidMobiles = res.invalid_mobiles;
        if (invalidMobiles) {
            invalidMobiles = invalidMobiles.replaceAll(",", "<br>");
        }
    }

    const Send = async () => {
        message.mobiles = message.mobiles.replace(/\n/g, ",").replace(/,,/g, ',');
        message.sms = convertMessage(message.sms);

        if (message.schedule_date && message.schedule_time) {
            message.scheduledon = dateToSchedule(formatDate(message.schedule_date, 'yyyy-mm-dd') + ' ' + message.schedule_time);
        }

        const [err, res] = await sendSms(message);

        if (err) {
            error = err;
            return;
        }

        totalMobiles = res.total_recipients;
        message.total_recipients = res.total_recipients;

        user.removeCredits(message.total_recipients);
        messageSended = true;
    }

    const Close = () => {
        error = "";
        showConfirm = false;
        invalidMobiles = '';
        showInvalidMobiles = false;
        dispatch('close', {});
    }

    const Cancel = () => {
        error = "";
        showConfirm = false;
        invalidMobiles = '';
        showInvalidMobiles = false;
        dispatch('cancel', {});
    }

    $: {
        if (showConfirm) {
            Validate();
        }
    }
</script>

<div class="popup-overlay" class:visible={ showConfirm }>
    <div class="modal modal-sm">
        <div class="modal-header">
            <div class="modal-title">
                Επιβεβαίωση Αποστολής
            </div>
            <div class="controls-right">
                {#if messageSended}
                    <span on:click="{ Close }"><i class="fa fa-times"></i></span>
                {:else}
                    <span on:click="{ Cancel }"><i class="fa fa-times"></i></span>
                {/if}
            </div>
        </div>
        <div class="modal-body">
            {#if error}
                <div class="alert alert-danger">
                    { error }
                </div>
                <button class="btn btn-default btn-block" on:click="{ Cancel }">ΕΠΙΣΤΡΟΦΗ</button>
            {:else}
                {#if !messageSended}
                    <table class="table table-report">
                        <tbody>
                        <tr>
                            <td width="30%">Αποστολέας:</td>
                            <td class="text-info">{ message.originator }</td>
                        </tr>
                        <tr>
                            <td>Μηνυμα:</td>
                            <td class="text-info text-italic">{ message.sms }</td>
                        </tr>
                        <tr>
                            <td>Αποστολή την:</td>
                            <td class="text-info">{ message.schedule_date && message.schedule_time ? formatDate(message.schedule_date, 'dd-mm-yyyy') + ' ' + message.schedule_time : 'Άμεσα' }</td>
                        </tr>
                        {#if totalDoubleMobiles > 0}
                            <tr>
                                <td>Διπλά τηλέφωνα:</td>
                                <td class="text-info">{ totalDoubleMobiles }</td>
                            </tr>
                        {/if}
                        {#if totalInvalidMobiles > 0}
                            <tr>
                                <td>Λάθος τηλέφωνα:</td>
                                <td class="text-info">
                                    <div class="float-left text-danger">
                                        <strong>{ totalInvalidMobiles }</strong>
                                    </div>
                                    <div class="float-right">
                                        <div class="text-link" title="εμφάνιση τηλεφώνων"
                                             on:click={ () => showInvalidMobiles = !showInvalidMobiles }>εμφάνιση
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            {#if showInvalidMobiles}
                                <tr>
                                    <td colspan="2">
                                        <MobilesContainer label="Μη έγκυροι αριθμοί κινητών" mobiles="{ invalidMobiles }"/>
                                    </td>
                                </tr>
                            {/if}
                        {/if}
                        <tr>
                            <td>Παραλήπτες:</td>
                            <td class="text-info">
                                { totalMobiles }
                                {#if totalMobiles == 0}
                                    <i class="fa fa-exclamation-triangle text-danger"></i>
                                {/if}
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    {#if totalInvalidMobiles > 0}
                        <p class="text-warning text-small mrg-b-lg">
                            Το μήνυμά σας περιέχει <strong>{ totalInvalidMobiles }</strong> μη έγκυρα τηλέφωνα που έχουν
                            αφαιρεθεί από τους παραλήπτες.
                        </p>
                    {/if}
                    {#if totalMobiles == 0}
                        <div class="alert alert-danger">
                            <i class="fa fa-exclamation-triangle"></i> Το μήνυμά σας δεν περιέχει έγκυρα τηλέφωνα
                            παραληπτών.
                        </div>
                    {:else}
                        <button class="btn btn-success btn-lg btn-block mrg-b-md" on:click="{ Send }">ΑΠΟΣΤΟΛΗ
                            ΜΗΝΥΜΑΤΟΣ
                        </button>
                    {/if}
                    <button class="btn btn-default btn-lg btn-block mrg-b-md" on:click="{ Cancel }">ΑΚΥΡΩΣΗ</button>

                {:else}
                    <div class="alert alert-success">
                        <p>Η αποστολή του μηνύματος ολοκληρώθηκε επιτυχώς.</p>
                        <p>Το μήνυμα στάλθηκε σε { totalMobiles } παραλήπτες.</p>
                    </div>
                    <button class="btn btn-success btn-lg btn-block" on:click="{ Close }">ΚΛΕΙΣΙΜΟ</button>
                {/if}
            {/if}
        </div>
    </div>
</div>
